import { useQuery } from 'react-apollo';

import { AlbumForUpload } from '../../../../../../apps/pro/views/AlbumFolder/AlbumFolderUpload/components/AlbumFolderUploadDestination/graphql';

const useSlideUploadSuccess = ({ albumId }) => {
  const { data: { album } = {} } = useQuery(AlbumForUpload, {
    variables: {
      id: albumId,
    },
    fetchPolicy: 'cache-and-network',
    skip: !albumId,
  });

  return {
    album,
    albumFolder: album?.album_folder,
  };
};

export default useSlideUploadSuccess;
